import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import * as htmlParser from 'react-html-parser';

import Video from '_core/components/Video';

const htmlViewStyle = () => ({
  tableWrapper: {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',

    '& > figure.table': {
      display: 'block',
      boxSizing: 'border-box',
      maxWidth: 'none',
      overflow: 'visible'
    },

    '& table': {
      borderCollapse: 'collapse'
    },

    '@media (max-width: 768px)': {
      '& table': {
        minWidth: 600,
        maxWidth: 'none'
      },

      '& td, & th': {
        whiteSpace: 'nowrap'
      }
    }
  }
});

class HtmlView extends React.PureComponent {
  static propTypes = {
    style: PropTypes.object,
    classes: PropTypes.object.isRequired,
    children: PropTypes.string
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  render() {
    const { style, classes, children } = this.props;

    const transform = (node, index) => {
      if (node.type === 'comment' || node.type === 'style') return null;

      if (!node.parent && node.type === 'tag') {
        if (!node.attribs) node.attribs = {};

        node.attribs['class'] = node.attribs['class']
          ? node.attribs['class'] + ' ck-content'
          : 'ck-content';
      }

      if (
        node.type === 'tag' &&
        node.name === 'oembed' &&
        node.parent?.type === 'tag' &&
        node.parent.name === 'figure' &&
        node.attribs?.url
      )
        return (
          <Video
            id={node.attribs.id}
            className={node.attribs['class']}
            src={node.attribs.url}
          />
        );

      let result = htmlParser.convertNodeToElement(node, index, transform);

      let propsReplace = null;

      if (node.type === 'tag') {
        if (style && style[node.name])
          propsReplace = prop(propsReplace, 'style', style[node.name]);
      }

      if (propsReplace)
        result = React.cloneElement(result, { ...result.props, ...propsReplace });

      if (node.type === 'tag' && isTableFigure(node)) {
        return (
          <div key={index} className={`${classes.tableWrapper} table-wrapper`}>
            {result}
          </div>
        );
      }

      if (
        node.type === 'tag' &&
        node.name === 'table' &&
        !isTableFigure(node.parent) &&
        !hasClass(node.parent, 'table-wrapper')
      ) {
        return (
          <div key={index} className={`${classes.tableWrapper} table-wrapper`}>
            {result}
          </div>
        );
      }

      return result;
    };

    return htmlParser.default(children || '', { transform });
  }
}

export default withStyles(htmlViewStyle)(HtmlView);

const prop = (props, name, value) => {
  if (!props) props = {};

  props[name] = value;

  return props;
};

const hasClass = (node, className) => {
  const classValue = node?.attribs?.class || node?.attribs?.className || '';

  return classValue.split(/\s+/).includes(className);
};

const isTableFigure = (node) =>
  node?.type === 'tag' && node.name === 'figure' && hasClass(node, 'table');
